import { request } from '@/plugins/http';

/**
 * 菜单列表
 * @param params
 * @returns {AxiosPromise}
 */
const getMenuTree = params => request('/menu/getMuneTree', params);

/**
 * 新增菜单
 * @param params
 * @returns {AxiosPromise}
 */
const addMenu = params => request('/menu/addMune', params);

/**
 * 修改菜单
 * @param params
 * @returns {AxiosPromise}
 */
const updateMenu = params => request('/menu/updateMenu', params);

/**
 * 删除菜单
 * @param params
 * @returns {AxiosPromise}
 */
const delMenus = params => request('/menu/delMenus', params);

/**
 * 删除菜单
 * @param params
 * @returns {AxiosPromise}
 */
const getMenu = params => request('/menu/getMenu', params);



export {
    getMenuTree,
    addMenu,
    updateMenu,
    delMenus,
    getMenu,
};
